import { api, state, ui } from "../../../../../../../../../interfaces/interfaces";

export const getJobDetails = async (jobId: number) => {
  const jobDetails = await api.jobDetails({ JobId: jobId });
  if (jobDetails.length > 0) {
    if (jobDetails[0]?.accountCode === 33500) {
      state.PossibleCC = true
      ui.ProblemMsg = "This job is potentialy for CARECLUB. Please check with customer.";
      ui.ProblemMsgVariant = "warning";
      ui.ProblemShowMsg = true;
    }
    return jobDetails[0];
  }
};

export const getCompletionDetails = async (jobId: number) => {
  const jobCompletion = await api.jobCompletion({ JobId: jobId });
  if (jobCompletion) return jobCompletion[0];
};
